<div class="notifications-panel flex column h-100">
  <div class="notifications-panel__card flex column gap-3 h-100 p-6 bg-white radius-3 brd brd-primary-lighter">
    <!-- Header -->
    <div class="notifications-panel__header box noshrink flex align-flex-start gap-1">
      <h3 class="notifications-panel__title box grow-fixed m-0 weight-medium">{{ "Notifications.Title" | translate }}</h3>
      <button type="button" class="notifications-panel__close box noshrink flex align-center justify-center cursor-pointer text-700 p-0" (click)="closeNotificationClicked.emit()">
        <app-icon name="outline-cross" size="xxs"></app-icon>
      </button>
    </div>

    <!-- Actions -->
    <div *ngIf="notifications.length" class="notifications-panel__actions box noshrink flex align-center justify-space-between py-3">
      <button
        type="button"
        class="notifications-panel__mark-all text-accent weight-normal p-0"
        [disabled]="!(unreadCount$ | async)"
        (click)="markAllAsRead()"
      >
        {{ "Notifications.MarkAllAsRead" | translate }}
      </button>
      <span *ngIf="unreadCount$ | async as unreadCount" class="notifications-panel__badge text-accent text-nowrap bg-white brd brd-primary-lighter">
        {{ "Notifications.UnreadCount" | translate: { count: unreadCount } }}
      </span>
    </div>

    <!-- List: the only scrolling area -->
    <div class="notifications-panel__list box grow-fixed scrollable scrollable--y flex column pr-4">
      <app-state-section class="notifications-panel__state" [state]="sectionState">
        <app-notification-item
          *ngFor="let notification of notifications; trackBy: trackById"
          [notification]="notification"
          (notificationClicked)="onNotificationClicked(notification)"
        ></app-notification-item>

        <button *ngIf="notifications.length && hasMoreNotifications" type="button" class="notifications-panel__load-more text-accent weight-normal py-3" (click)="loadMore()">
          {{ "Notifications.LoadMore" | translate }}
        </button>

        <!-- Empty state -->
        <div *ngIf="!notifications.length" class="notifications-panel__empty flex column align-center justify-center gap-3 p-6 text-center">
          <span class="notifications-panel__empty-icon flex align-center p-3 bg-accent-lighter text-accent">
            <app-icon name="twotone-notification-bing"></app-icon>
          </span>
          <div class="notifications-panel__empty-text flex column align-center gap-1">
            <p class="notifications-panel__empty-title m-0 weight-normal">{{ "Notifications.EmptyTitle" | translate }}</p>
            <p class="notifications-panel__empty-label m-0 text-600">{{ "Notifications.EmptyLabel" | translate }}</p>
          </div>
        </div>
      </app-state-section>
    </div>
  </div>
</div>
